var _circle, _circle2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDividerInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 116,
    viewBox: "0 0 20 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 4.74463,
    r: 3.5,
    stroke: "#FFC222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 111.745,
    r: 4,
    fill: "#FFC222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.74463V113.745",
    stroke: "#FFC222"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6527 54.0018C16.6527 53.2469 16.4123 52.6046 15.9316 52.075C15.4509 51.5454 14.8672 51.2806 14.1805 51.2806V49.6611H3.33325L3.33325 64.3125H6.76381V66.8333L10.3888 69.8278H14.1805L14.1805 68.132C14.8672 68.132 15.4509 67.8678 15.9316 67.3393C16.4123 66.8109 16.6527 66.1692 16.6527 65.4143C16.6527 64.6594 16.4123 64.0172 15.9316 63.4875C15.4509 62.9579 14.8672 62.6931 14.1805 62.6931V56.7195C14.8657 56.7195 15.449 56.4552 15.9305 55.9268C16.412 55.3984 16.6527 54.7567 16.6527 54.0018ZM15.2638 54C15.2638 54.331 15.1585 54.6124 14.9478 54.8441C14.7372 55.0758 14.4814 55.1917 14.1805 55.1917C13.8796 55.1917 13.6238 55.0758 13.4131 54.8441C13.2025 54.6124 13.0971 54.331 13.0971 54C13.0971 53.669 13.2025 53.3876 13.4131 53.1559C13.6238 52.9242 13.8796 52.8083 14.1805 52.8083C14.4814 52.8083 14.7372 52.9242 14.9478 53.1559C15.1585 53.3876 15.2638 53.669 15.2638 54ZM12.7916 51.1889V51.7694C12.4583 52.0292 12.1921 52.3477 11.993 52.7249C11.7939 53.1022 11.6944 53.5223 11.6944 53.9854C11.6944 54.4484 11.7962 54.8709 11.9999 55.2528C12.2036 55.6347 12.4675 55.9556 12.7916 56.2153V62.7848H4.72213L4.72213 51.1889H12.7916ZM15.2638 65.4125C15.2638 65.7435 15.1585 66.0249 14.9478 66.2566C14.7372 66.4883 14.4814 66.6042 14.1805 66.6042C13.8796 66.6042 13.6238 66.4883 13.4131 66.2566C13.2025 66.0249 13.0971 65.7435 13.0971 65.4125C13.0971 65.0815 13.2025 64.8001 13.4131 64.5684C13.6238 64.3367 13.8796 64.2208 14.1805 64.2208C14.4814 64.2208 14.7372 64.3367 14.9478 64.5684C15.1585 64.8001 15.2638 65.0815 15.2638 65.4125ZM11.0416 64.3125L11.0416 68.4528L8.15269 66.0695L8.15269 64.3125H11.0416Z",
    fill: "#FFC222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_1417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white",
    transform: "matrix(0 1 1 0 0 48.7446)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerInfo);
export default __webpack_public_path__ + "static/media/divider-info.0295558f262dd05166d8ab10f1438d0c.svg";
export { ForwardRef as ReactComponent };